import { AjaxLoader } from './AjaxLoader';
import createDom from '../dom/create.js';

/**
 * Loads urls using ajax and injects them into the DOM
 * @extends AjaxLoader
 * @category loader
 * @author Geoffrey Mayeux
 */
class DomLoader extends AjaxLoader{
	/**
	 * Create a DomLoader
 	 * @param {Object} options An Option object
	 */
	constructor(options = {}){
		options.headers = options.headers ? options.headers : {'X-Requested-With':'XMLHttpRequest'};
		super(options);
	}

	accepts(item){
		return typeof item == "string";
	}

	async loadItem(item){
		return createDom(await super.loadItem(item));
	}

}

export default DomLoader;
export { DomLoader };